<script lang="ts">
	import type { Mediator } from 'types/common'

	import LoadItemModal from '@isoftdata/svelte-load-item-modal'

	import { graphql, type InventoryLookup$result } from '$houdini'
	import { getContext } from 'svelte'

	type Item = InventoryLookup$result['inventories']['items'][number]

	interface Props {
		chooseItem: (item: Item) => void | Promise<void>
	}

	let { chooseItem }: Props = $props()

	let loadPartModal: LoadItemModal<Item> | undefined = $state()

	const mediator = getContext<Mediator>('mediator')

	const inventoryLookupQuery = graphql(`
		query InventoryLookup($filter: InventoryFilter) {
			inventories(filter: $filter) {
				items {
					id
					store {
						id
						code
						name
					}
					tagNumber
					skuNumber
					inventoryType {
						id
						name
					}
				}
			}
		}
	`)

	export function show() {
		loadPartModal?.open()
	}
</script>

<LoadItemModal
	title="Parts by Tag Number"
	itemIdProp="id"
	itemDisplayProp="tagNumber"
	bind:this={loadPartModal}
	doSearch={async searchString => {
		const { data } = await inventoryLookupQuery.fetch({
			variables: {
				filter: {
					tagNumber: searchString,
				},
			},
		})
		return data?.inventories.items ?? []
	}}
	lookupError={error =>
		mediator.publish('showMessage', {
			heading: 'Error Fetching Parts',
			message: error.message,
			type: 'danger',
			time: false,
		})}
	chooseItem={({ item }) => chooseItem(item)}
>
	{#snippet children({ item })}
		<div class="w-100 d-flex justify-content-between">
			<h5 class="mb-1">{item.tagNumber}</h5>
			<h5
				class="mb-1"
				title={item.store.name}
			>
				Store {item.store.code}
			</h5>
		</div>
		<div class="w-100">{item.inventoryType?.id} - {item.inventoryType?.name}</div>
		<small>SKU #{item.skuNumber}</small>
	{/snippet}
</LoadItemModal>
